import { useState } from 'react';
import { useDispatch } from 'store/hooks';

/* eslint-disable @typescript-eslint/no-explicit-any */

export function useRequestData<Payload extends any[], Result>(
    asyncAction: (
        handler: (error: any, result?: Result) => void,
        ...payload: Payload
    ) => void,
    initialValue: Result
) {
    const dispatch = useDispatch();

    const [data, setData] = useState<Result>(initialValue);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const request = async (...payload: Payload) => {
        setIsError(false);
        setIsLoading(true);
        dispatch(
            asyncAction(
                (error: any, result?: Result) => {
                    if (error) {
                        setIsError(true);
                    } else {
                        setData(result!);
                    }
                    setIsLoading(false);
                },
                ...payload
            ) as any
        );
    };

    return { request, data, isLoading, isError };
}

export function useMakeRequest() {
    const dispatch = useDispatch();
    return <Payload extends any[], Result>(
            asyncAction: (
                handler: (error: any, result: Result) => void,
                ...payload: Payload
            ) => void
        ) =>
        async (...payload: Payload) =>
            new Promise<Result>((resolve, reject) => {
                dispatch(
                    asyncAction(
                        (error: any, result: Result) => {
                            if (error?.response) {
                                reject(error.response);
                            } else if (error) {
                                reject(error);
                            }
                            resolve(result);
                        },
                        ...payload
                    ) as any
                );
            });
}
